
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.034 0H.966A.966.966 0 000 .966v22.067c0 .534.433.967.966.967h22.067a.966.966 0 00.967-.966V.966A.966.966 0 0023.034 0zm-.967 22.067H1.933V1.933h20.134v20.134z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M23.066 7.636H.966V9.57h22.1V7.636zM23.066 14.182H.966v1.932h22.1v-1.932z","fill":"currentColor"}})])
          )
        }
      }
    